import { render } from "./series-pack-header.vue?vue&type=template&id=767f44d0"
import script from "./series-pack-header.vue?vue&type=script&lang=js"
export * from "./series-pack-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__